import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import moment from 'moment';
import lodash from 'lodash';
const insuredFactorFun = {
  // 根据规则对象返回结果
  insuredSize: (conditionFun, insuredAge, productAge, insuredLength, certifyValueLength) => {
    return conditionFun(Number(insuredLength), Number(certifyValueLength));
  },
  insuredAge: (conditionFun, insuredAge, productAge, insuredLength, certifyValueLength) => {
    return conditionFun(Number(insuredAge), Number(productAge));
  }
};

const getAgeTodays = time => {
  const m1 = moment(moment().format('YYYY-MM-DD')); // 获取需要对比的时间

  const m2 = moment(moment(time).format('YYYY-MM-DD')); // 计算相差多少天 day可以是second minute

  const day = m1.diff(m2, 'day');
  return day;
};

const unitList = {
  // 根据单位不同，返回相同单位的数字
  day: age => {
    return age;
  },
  year: (age, condition) => {
    let years = moment().subtract(Number(age), 'y');

    if (condition === 'lessThanEquals') {
      years = moment().subtract(Number(age) + 1, 'y').add(1, 'd');
    }

    if (condition === 'greaterThan') {
      years = moment().subtract(Number(age) + 1, 'y').add(1, 'd');
    }

    const newAge = years.format('YYYY-MM-DD');
    const days = getAgeTodays(newAge); // console.log('years==>', age, condition, newAge,)

    return days;
  }
};
const conditionRuleFun = {
  // 根据判断条件进行值的对比
  greaterThan: (a, b) => {
    return a > b;
  },
  greaterThanEquals: (a, b) => {
    return a >= b;
  },
  equals: (a, b) => {
    return a === b;
  },
  lessThan: (a, b) => {
    return a < b;
  },
  lessThanEquals: (a, b) => {
    return a <= b;
  }
};
const flagCondition = {
  // 判断所有条件满足情况
  and: (flags = []) => {
    let flag = true;
    flags && flags.forEach(item => {
      flag = flag && item;
    });
    return flag;
  },
  or: (flags = []) => {
    let flag = true;
    flags && flags.forEach(item => {
      flag = flag || item;
    });
    return flag;
  }
};
const whetherInsuredFun = {
  // 判断是否开启投保本产品
  Y: () => {
    return true;
  },
  N: () => {
    return false;
  }
};

const judgeResult = props => {
  // 根据单个规则返回比较的结果
  const {
    certifyName,
    certifyCode,
    certifyValue,
    valueUnit,
    birthday,
    insuredLength
  } = props;
  const productVarAge = valueUnit && unitList[valueUnit](certifyValue, certifyName);
  const insuredVarAge = getAgeTodays(birthday);
  const judgeConditionFun = certifyName && conditionRuleFun[certifyName];
  const result = insuredFactorFun[certifyCode](judgeConditionFun, insuredVarAge, productVarAge, insuredLength, certifyValue);
  return result;
};

export const rulesProduct = (packageList, insuredItem, insuredLength) => {
  // 根据规则判断被保人是否投保当前产品
  const {
    birthday
  } = insuredItem;
  const newPackage = [];
  packageList && packageList.forEach(packItem => {
    const newPackItem = _objectSpread({}, packItem);

    newPackItem.productList = [];
    Array.isArray(packItem.productList) && packItem.productList.length && packItem.productList.forEach(productItem => {
      const {
        collocationRule = false
      } = productItem;

      if (!collocationRule) {
        newPackItem.productList.push(productItem);
        return;
      }

      let sumFLag = true;
      const {
        whetherInsured,
        conditionInfo = [],
        conditionRelation
      } = collocationRule;
      const flags = [];
      conditionInfo && conditionInfo.forEach(conditionItem => {
        const {
          certifyCode,
          certifyName,
          certifyValue,
          valueUnit,
          relationType
        } = conditionItem;
        const singleFlag = judgeResult({
          certifyName: relationType,
          certifyCode,
          certifyValue,
          valueUnit,
          birthday,
          insuredLength
        }); //

        flags.push(singleFlag);
        sumFLag = flagCondition[conditionRelation](flags);
      }); //

      if (whetherInsuredFun[whetherInsured]()) {
        sumFLag && newPackItem.productList.push(productItem);
      } else {
        !sumFLag && newPackItem.productList.push(productItem);
      }
    });
    newPackage.push(newPackItem);
  });
  const filterPackage = [];
  newPackage.forEach(item => {
    if (item.productList && item.productList.length > 0) {
      filterPackage.push(item);
    }
  });
  return lodash.cloneDeep(filterPackage);
};